import React, { useEffect, useState } from 'react';
import '../assets/css/Feed.css';
import bannerImage from '../assets/images/chat-banner.png'; // ✅ banner import

const feedUrls = [
  'https://realty.economictimes.indiatimes.com/rss/topstories',
  'https://realty.economictimes.indiatimes.com/rss/recentstories',
  'https://realty.economictimes.indiatimes.com/rss/industry',
];
// const feedUrls = [];

const formatDate = (pubDate) => {
  const date = new Date(pubDate);
  const datePart = date.toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' });
  const timePart = date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
  return (<>{datePart}<br />{timePart}</>);
};

const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

const truncateText = (text, limit = 120) => (text.length > limit ? text.slice(0, limit) + '...' : text);

const NewsFeed = ({ onBannerClick }) => {
  const [newsItems, setNewsItems] = useState([]);
  const [feedIndex, setFeedIndex] = useState(0);

  useEffect(() => {
    const fetchRSS = async () => {
      try {
        const response = await fetch(`https://api.allorigins.win/get?url=${encodeURIComponent(feedUrls[feedIndex])}`);
        // const response = [];
        const data = await response.json();
        const parser = new DOMParser();
        const xml = parser.parseFromString(data.contents, 'text/xml');

        const items = Array.from(xml.querySelectorAll('item')).map((item) => ({
          title: item.querySelector('title')?.textContent || '',
          link: item.querySelector('link')?.textContent || '',
          description: item.querySelector('description')?.textContent || '',
          pubDate: item.querySelector('pubDate')?.textContent || '',
          thumbnail: item.querySelector('media\\:content, content')?.getAttribute('url') || '',
        }));

        setNewsItems(items);
      } catch (error) {
        console.error('Error fetching RSS feed:', error);
      }
    };

    fetchRSS();
    const interval = setInterval(() => setFeedIndex((i) => (i + 1) % feedUrls.length), 10000);
    return () => clearInterval(interval);
  }, [feedIndex]);

  return (
    <div className="news-feed">
      {/* 🏙️ Banner Section */}
      <div className="banner-section" onClick={onBannerClick}>
        <img src={bannerImage} alt="Featured Property Banner" className="banner-image" />
      </div>

      <h3>Real Estate News</h3>
      <ul className="news-list">
        {newsItems.map((item, index) => (
          <div className="news-item" key={index}>
            <div className="news-left">
              {item.thumbnail && <img src={item.thumbnail} alt="thumbnail" className="thumbnail" />}
              {item.pubDate && <div className="pub-date">{formatDate(item.pubDate)}</div>}
            </div>
            <div className="news-content">
              <a href={item.link} target="_blank" rel="noopener noreferrer" className="news-title">
                {item.title}
              </a>
              <p className="description">{truncateText(stripHtml(item.description))}</p>
            </div>
          </div>
        ))}
      </ul>
    </div>
  );
};

export default NewsFeed;
